import { render } from "./Labellingv2.vue?vue&type=template&id=517d31f7"
import script from "./Labellingv2.vue?vue&type=script&lang=js"
export * from "./Labellingv2.vue?vue&type=script&lang=js"

import "./Labellingv2.vue?vue&type=style&index=0&id=517d31f7&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__